import React, { FC, useState } from 'react';
import { IconButton } from '@material-ui/core';
import { LocationOn } from '@material-ui/icons';

import MapDialog from '@app/components/common/modals/map';
interface MapViewModalProps {
  coords: [number, number];
  title: string;
}

const MapViewModal: FC<MapViewModalProps> = (props) => {
  const { coords, title } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <LocationOn />
      </IconButton>
      <MapDialog open={open} setOpen={setOpen} title={title} coords={coords} />
    </>
  );
};

export default MapViewModal;
